import React, { useEffect, useRef } from 'react';

function ImageLightbox({ image, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  return (
    <div
      ref={overlayRef}
      className="image-lightbox-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label="Image viewer"
    >
      <button
        className="lightbox-close-btn"
        onClick={onClose}
        aria-label="Close image viewer"
      >
        &times;
      </button>
      <div className="lightbox-content">
        <img
          src={image.url}
          alt={image.alt || 'Question image'}
          className="lightbox-image"
        />
        {image.caption && (
          <p className="lightbox-caption">{image.caption}</p>
        )}
      </div>
    </div>
  );
}

export default ImageLightbox;
